import { Outlet } from 'react-router'

const PPCLayout = () => {
  return (
    <Outlet />
  )
}

export default PPCLayout